import { useEffect, useState } from "react"

export default function DesignNameDialog({
  initialName,
  onCancel,
  onSave
}: {
  initialName: string
  onCancel: () => void
  onSave: (name: string) => void
}) {
  const [name, setName] = useState(initialName)

  useEffect(() => {
    setName(initialName)
  }, [initialName])

  const trimmedName = name.trim()

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
      <div className="w-full max-w-md rounded-md bg-white p-4 shadow-sm">
        <h3 className="text-base font-semibold text-gray-800">
          Edit design name
        </h3>

        <label className="mt-4 block text-xs font-medium text-gray-600">
          Enter name
        </label>
        <input
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          className="mt-1 w-full rounded border border-blue-700 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-700"
          autoFocus
        />

        <div className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-blue-800">
          <span className="mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-blue-800 text-[10px] font-semibold text-white">
            i
          </span>
          <p>
            Please note that the design name is intended for your internal use
            only and is not used to identify the design in official correspondence
            with the Office. The official design number is assigned after receipt
            confirmation.
          </p>
        </div>

        <div className="mt-5 flex justify-end gap-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={() => onSave(trimmedName)}
            disabled={!trimmedName}
            className={`rounded px-4 py-2 text-sm text-white ${
              trimmedName
                ? "bg-blue-800 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}
